import React from 'react'

const excellence = props =>{
     return(
        <div className="banner-image excellence">
            <div className="mx-width">
                <div className="py-5">
                    <h2 className="heading2 pt-5 font-weight-bold text-center">Over <span className="text-color2">10 Years </span> of Service Excellence</h2>
                    <h6 className="heading6 px-md-5 pt-5 fw-sb text-center">We, the Delta Global Consultants, are study abroad education consultants with more than ten years of experience helping students to reach academic goals. We provide students with the best opportunities to seek education in global academic institutions of higher learning, matching their academic interests and educational objectives.</h6>
                    
                </div>
            </div>
        </div>
     )
}

export default excellence;